import { DependenciesInjection } from "app/di/DependencyInjection";
import { ActionRepositoryImpl } from "../data/ActionRepositoryImpl";
import { IActionRepository } from "../domain/repositories/IActionRepository";
import { ActionUseCase } from "../domain/useCases/ActionUseCase";
import { ActionToken } from "./ActionToken";

export class ActionInjection {
  static initInjections() {
    DependenciesInjection.register<IActionRepository>(
      ActionToken.IActionRepository,
      ActionRepositoryImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ActionUseCase>(
      ActionToken.ActionUseCase,
      ActionUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IActionRepository>(
      ActionToken.IActionRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ActionUseCase>(
      ActionToken.ActionUseCase,
    );
  }
}
